<template>
  <v-form ref="userForm">
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <v-card elevation="6" class="pl-4 pr-4 pb-4 mt-0 mb-0">
              <v-row>
                <v-col cols="6">
                  <v-card-subtitle class="pl-0 ml-0">
                    <h3>User Details</h3>
                  </v-card-subtitle>
                  <v-text-field ref="emailField" v-model="userData.email" :rules="[rules.required]"
                    label="Email Address *" outlined>
                  </v-text-field>
                  <v-text-field v-model="userData.forename" :rules="[rules.required]" label="Forename *" outlined>
                  </v-text-field>
                  <v-text-field v-model="userData.surname" :rules="[rules.required]" label="Surname *" outlined>
                  </v-text-field>
                  <v-text-field v-model="userData.mobile" label="Mobile Phone" outlined></v-text-field>
                  <v-text-field v-model="userData.phone" label="Home Phone" outlined></v-text-field>
                  <v-card class="pl-4 pr-4 pb-4" elevation="6">
                    <v-card-subtitle class="pl-0 ml-0">
                      <h3>Password</h3>
                    </v-card-subtitle>
                    <v-text-field ref="passwordField" v-model="newPassword" :rules="checkPasswordIsValid()"
                      label="New Password *" autocomplete="false" outlined :type="newPasswordType" :append-icon="
                        newPasswordType == 'password' ? 'mdi-eye-off' : 'mdi-eye'
                      " @click:append="
  newPasswordType =
  newPasswordType == 'password' ? 'text' : 'password'
">
                    </v-text-field>
                    <v-spacer />
                    <v-btn v-if="user" color="primary" right @click="updatePassword()">Update Password</v-btn>
                    <v-card-subtitle v-if="updatePasswordMessage" class="pr-0 pl-0 pb-0 mb-0">
                      <v-alert dismissible close-text="Close Alert" border="left" :type="getUpdatePasswordResponseType()">
                        {{ this.updatePasswordMessage }}
                      </v-alert>
                    </v-card-subtitle>
                  </v-card>
                  <v-textarea v-if="user" class="mt-4 pt-4" v-model="userData.signature" label="Signature" outlined>
                  </v-textarea>
                </v-col>
                <v-col cols="6">
                  <v-card-subtitle class="pl-0 ml-0">
                    <h3>Contact Details</h3>
                  </v-card-subtitle>
                  <v-text-field v-model="userData.address1" label="Address 1" outlined></v-text-field>
                  <v-text-field v-model="userData.address2" label="Address 2" outlined></v-text-field>
                  <v-text-field v-model="userData.address3" label="Address 3" outlined></v-text-field>
                  <v-text-field v-model="userData.town" label="Town" outlined></v-text-field>
                  <v-text-field v-model="userData.county" :rules="[rules.required]" label="County / Region *" outlined></v-text-field>
                  <v-text-field v-model="userData.postcode" label="Postcode / ZIP" outlined></v-text-field>
                  <v-select :items="countryData" :rules="[rules.required]" item-text="country" item-value="id"
                    v-model="userData.countryId" label="Country *" outlined></v-select> 

                  <v-card v-if="user" class="pl-4 pr-4 pb-4 mt-0 mb-0" elevation="6">
                    <v-card-subtitle class="pl-0 ml-0">
                      <h3>Change Avatar</h3>
                    </v-card-subtitle>
                    <v-row>
                      <v-col>Current Avatar:
                        <v-list-item-avatar outlined rounded size="80" left v-if="userData.avatar">
                          <v-img :src="getAvatarUrl(userData.avatar)"></v-img>
                        </v-list-item-avatar>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-file-input outlined chips show-size accept="image/*"
                          label="Click here to select a new avatar" @change="avatarFileChanged"></v-file-input>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-spacer />
                        <v-btn color="primary" dark class="mb-2" @click="uploadNewAvatar">Upload</v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-card-subtitle v-if="updateAvatarMessage" class="pr-0 pl-0 pb-0 mb-0">
                          <v-alert dismissible close-text="Close Alert" border="left" :type="getUpdateAvatarResponseType()">
                            {{ this.updateAvatarMessage }}
                          </v-alert>
                        </v-card-subtitle>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer />
          <v-col cols="12">
            <v-card v-if="userData && loggedOnUserIsAdmin()" class="pl-4 pr-4 pb-4 mt-0 mb-0">
              <v-card-title> Admin Functions </v-card-title>
              <v-row>
                <v-col cols="6">
                  <v-checkbox v-model="userData.isOwner" label="Site Owner" color="primary" :true-value="1"
                    :false-value="0"></v-checkbox>
                  <v-checkbox v-model="userData.isModerator" label="Moderator" color="primary" :true-value="1"
                    :false-value="0"></v-checkbox>
                  <v-checkbox v-model="userData.emailWhenMessageReceived" label="Email When Message Received"
                    color="primary" :true-value="1" :false-value="0"></v-checkbox>
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-model="userData.isBanned" label="Banned" color="primary" :true-value="1"
                    :false-value="0">
                  </v-checkbox>
                  <v-card-subtitle>Banned By: </v-card-subtitle>
                  <v-card-subtitle>{{ userData.bannedByEmail }}</v-card-subtitle>
                  <v-card-subtitle>Banned On: </v-card-subtitle>
                  <v-card-subtitle>{{ formatDate(userData.bannedOn) }}</v-card-subtitle>
                  <v-text-field v-model="userData.bannedReason" label="Banned Reason" outlined></v-text-field>
                </v-col>
              </v-row>
            </v-card>
            <v-card>
              <v-row>
                <v-col cols="12">
                  <v-card-subtitle v-if="updateUserDetailsMessage" class="pr-4 pl-4 pb-0 mb-0 mt-0 pt-0">
                    <v-alert dismissible close-text="Close Alert" border="left" :type="getUpdateUserDetailsResponseType()">
                      {{ this.updateUserDetailsMessage }}
                    </v-alert>
                  </v-card-subtitle>
                  <v-card-subtitle>
                    <v-btn color="primary" absolute right :loading="saveProcessing" @click="saveUserDetails()">Save
                    </v-btn>
                    <v-btn color="error" @click="resetUserFields()">Reset</v-btn>
                    <v-spacer />
                  </v-card-subtitle>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-spacer />
        </v-row>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import serverFunctions from "@/functions/serverFunctions";
import dateFunctions from "@/functions/dateFunctions";
import userFunctions from "@/functions/userFunctions";

export default {
  props: ["user"],
  data: () => ({
    userData: null,
    originalUser: null,
    userList: null,
    searchText: null,
    selectedUser: null,
    newPassword: null,
    newPasswordType: "password",
    updatePasswordMessage: null,
    countryData: null,
    updateUserDetailsMessage: null,
    updateUserDetailsSucceeded: null,
    updateAvatarSucceeded: null,
    updateAvatarMessage: null,
    newAvatar: null,
    newAvatarBase64: null,
    saveProcessing: false,
    rules: {
      required: (value) => !!value || "Required",
    },

  }),
  mounted() {
    this.$refs.userForm.validate()
  },
  beforeMount() {
    if (this.user) {
      this.userData = JSON.parse(JSON.stringify(this.user));
      this.originalUser = JSON.parse(JSON.stringify(this.user));
    } else {
      this.userData = this.getBlankUser();
      this.originalUser = this.getBlankUser();
    }
    this.getCountryData();
  },
  afterMount() {
  },
  methods: {
    getUpdateAvatarResponseType() {
      if (this.updateAvatarMessage) {
        return this.updateAvatarSucceeded ? "success" : "error";
      }
    },
    getAvatarUrl(avatar) {
      return userFunctions.getFullAvatarUrl(avatar);
    },
    avatarFileChanged(file) {
      this.updateAvatarSucceeded = null;
      this.updateAvatarMessage = null;
      this.newAvatar = null;
      this.newAvatarBase64 = null;
      if (file) {
        this.newAvatar = file;
        this.readBase64Image(file);
      }
    },
    async readBase64Image(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.newAvatarBase64 = e.target.result.slice(e.target.result.indexOf(",") + 1);
      };
      await reader.readAsDataURL(file);
    },
    async uploadNewAvatar() {
      this.updateAvatarSucceeded = null;
      this.updateAvatarMessage = null;

      if (!this.newAvatar || !this.newAvatarBase64) {
        this.updateAvatarSucceeded = false;
        this.updateAvatarMessage = "Please Select An Image";
        return; //TODO error handling
      }
      let uploadAvatarRequest = serverFunctions.getUploadImageRequest(
        userFunctions.getLoggedInUser(),
        this.newAvatar.name,
        this.newAvatar.type,
        this.newAvatarBase64
      );

      let uploadAvatarResponse = await serverFunctions.getPostResponse(
        "/uploadAvatar",
        uploadAvatarRequest
      );

      this.updateAvatarSucceeded = uploadAvatarResponse[0].success;
      this.updateAvatarMessage = this.updateAvatarSucceeded
        ? "Avatar Updated"
        : uploadAvatarResponse[0].failureReason;

      this.userData.avatar = uploadAvatarResponse[0].imagePathAndFilename;
    },
    checkPasswordIsValid() {
      if (!this.user && !this.newPassword) {
        return ["Password is a mandatory field"];
      }
      if (this.newPassword && this.newPassword.length < 8) {
        return ["Password must be at least 8 characters"];
      }
      return []
    },
    getBlankUser() {
      let blankUser = {};
      return JSON.parse(JSON.stringify(blankUser));
    },
    mandatoryFieldsArePresent() {
      if (!this.userData.email || !this.userData.forename || !this.userData.surname) {
        this.$refs["emailField"].$el.scrollIntoView(true);
        return false;
      }
      if (!this.user && !this.newPassword) {
        return false;
      }
      return true;
    },
    passwordIsValid() {
      if (this.newPassword && (this.checkPasswordIsValid().length > 0)) {
        this.$refs["passwordField"].$el.scrollIntoView(true);
        return false;
      }
      return true;
    },
    async saveUserDetails() {
      if (!this.mandatoryFieldsArePresent()) {
        this.updateUserDetailsSucceeded = false;
        let errorMessage = (this.user) ? "Email, Forename, Surname and Country are all mandatory fields" : "Email, Forename, Surname, Country and Password are all mandatory fields";
        this.updateUserDetailsMessage = errorMessage
        return;
      }
      if (!this.passwordIsValid()) {
        this.updateUserDetailsSucceeded = false;
        let errorMessage = "Please enter a valid password";
        this.updateUserDetailsMessage = errorMessage
        return;
      }
      this.updateUserDetailsMessage = null;

      const getUpdateUserRequest = serverFunctions.getUpdateUserDataRequestObject(
        userFunctions.getLoggedInUser(),
        this.userData
      );
      let saveUserEndpoint = (this.user) ? "/updateUser" : "/registerUser";
      if (!this.user) { //registering
        getUpdateUserRequest.updatedUser.password = this.newPassword;
      }
      this.saveProcessing = true;
      let updateUserResponse = await serverFunctions.getPostResponse(
        saveUserEndpoint,
        getUpdateUserRequest
      );

      this.saveProcessing = false;
      this.updateUserDetailsSucceeded = updateUserResponse[0].success;

      let successMessage = (updateUserResponse[0].successMessage) ? updateUserResponse[0].successMessage : "Update Successful" ;

      this.updateUserDetailsMessage = this.updateUserDetailsSucceeded
        ? successMessage
        : updateUserResponse[0].failureReason;

      if (this.updateUserDetailsSucceeded) { //processed successfully
        if(!this.user) { //registered
        this.$router.push("/registrationprocessed")
        }
        else {
          this.userData = updateUserResponse[0].updatedUser;
          this.originalUserData = JSON.parse(JSON.stringify(this.userData));
        }
      }
    },
    async getCountryData() {
      this.countryData = await serverFunctions.getResponse("/getCountries");
    },
    getUpdateUserDetailsResponseType() {
      if (this.updateUserDetailsMessage) {
        return this.updateUserDetailsSucceeded ? "success" : "error";
      }
    },
    loggedOnUserIsAdmin() {
      return (
        userFunctions.userIsLoggedIn() &&
        (userFunctions.currentUserIsOwner() || userFunctions.currentUserIsModerator())
      );
    },
    formatDate(date) {
      if (date) {
        return dateFunctions.formatPalmDateTime(date.slice(0, 8), date.slice(8, 14));
      }
    },
    getUpdatePasswordResponseType() {
      return "success";
    },
    resetUserFields() {
      this.userData = JSON.parse(JSON.stringify(this.originalUser));
    },
    async updatePassword() {
      if (this.checkPasswordIsValid().length > 0) {
        return;
      }
      
      const updatePasswordRequest = serverFunctions.getAdminUpdatePasswordRequest(
        userFunctions.getLoggedInUser(),
        this.userData.email,
        this.newPassword
      );

      let updatePasswordResponse = await serverFunctions.getPostResponse(
        "/adminUpdatePassword",
        updatePasswordRequest
      );
      this.updatePasswordSucceeded = updatePasswordResponse[0].success;
      this.updatePasswordMessage = this.updatePasswordSucceeded
        ? "Password Changed"
        : updatePasswordResponse[0].failureReason;
    },
  },
};
</script>
